import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";
import {
  FONT_FAMILY_OPTIONS,
  FONT_WEIGHT_OPTIONS,
} from "../../../constants/document";
import { ASSET } from "../../../constants";
import FontWeightDropdown from "./FontWeightDropdown";
import { checkStylesInSelection } from "../../../utils/editorUtils";
import { getClosestFontWeightStyle } from "../../../utils/draftUtils";

const { FONT_STYLES_WITH_OPTIONS } = ASSET;

export default class CustomFontStyle extends Component {
  listRef = {};

  constructor(props) {
    super(props);
    this.state = {
      fontFamilyTitle: "Open Sans",
      fontWeight: null,
      hoveredID: "",
      style: {},
    };
  }

  componentDidMount = () => {
    this._setCurrentSelectedStyle();
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentDidUpdate = () => {
    this._setCurrentSelectedStyle();
  };

  componentWillUnmount = () => {
    this.setState({
      hoveredID: "",
      style: {},
    });
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _handleClick = e => {
    if (
      !this.node.contains(e.target) &&
      this.props.activeToolbarDropDown === "FONT_STYLE"
    ) {
      this.props.toogleToolbarDropDown(null);
    }

    if (
      this.node.contains(e.target) &&
      this.props.activeToolbarDropDown === "FONT_STYLE"
    ) {
      // prevent loosing editor focus when style/weight is selected
      e.preventDefault();
    }
  };

  _saveMetaData = (fontFamily, fontWeight) => {
    // update font styles in recent styles
    const updateRecentStyles = this.props.metaData
      ? { ...this.props.metaData.recentStyles }
      : {};
    if (this.props.allowToSaveRecentStyles) {
      if (
        this.props.metaData &&
        this.props.metaData.recentStyles &&
        this.props.metaData.recentStyles.fontStyles
      ) {
        const { fontStyles } = this.props.metaData.recentStyles;
        const tempFontStyles = [...fontStyles];
        const findIndex = tempFontStyles.findIndex(fontStyle => {
          if (fontStyle.fontWeight) {
            return (
              fontStyle.fontFamily === fontFamily &&
              fontStyle.fontWeight === fontWeight
            );
          }
          return fontStyle.fontFamily === fontFamily;
        });
        if (findIndex !== -1) {
          tempFontStyles.splice(findIndex, 1);
        }
        tempFontStyles.unshift({ fontFamily, fontWeight });
        if (tempFontStyles.length > 5) {
          tempFontStyles.splice(tempFontStyles.length - 1, 1);
        }
        updateRecentStyles.fontStyles = [...tempFontStyles];
      } else {
        updateRecentStyles.fontStyles = [{ fontFamily, fontWeight }];
      }
    }

    const data = [
      {
        op: "replace",
        field: "meta_data",
        value: {
          meta_data: {
            ...this.props.metaData,
            FONTFAMILY: fontFamily,
            FONTWEIGHT: fontWeight,
            recentStyles: updateRecentStyles,
          },
        },
      },
    ];

    this.props.saveMetaData(data);
  };

  _onChange = (fontStyle, fontValue, fontWeightStyle, fontWeight) => {
    if (!fontWeight || !fontWeightStyle) {
      const { newFontWeightStyle, newFontWeight } = this._getClosestFontWeight(
        fontStyle,
        fontValue,
      );
      fontWeightStyle = newFontWeightStyle;
      fontWeight = newFontWeight;
    }

    const { fontFamilyUpdate } = this.props;
    this._saveMetaData(fontStyle, fontWeightStyle);
    fontFamilyUpdate(fontStyle, fontValue, fontWeightStyle);
    this.setState({
      fontFamilyTitle: fontValue,
      fontWeight,
    });
    this.props.toogleToolbarDropDown(null);
  };

  _toggleDropdown = event => {
    event.preventDefault();
    this.props.toogleToolbarDropDown(
      this.props.activeToolbarDropDown === "FONT_STYLE" ? null : "FONT_STYLE",
    );
  };

  _setListDropdownStyles = e => {
    if (this.listRef && this.listRef[e.target.id]) {
      const ele = this.listRef[e.target.id];

      const rect = ele.getBoundingClientRect();
      if (this.state.hoveredID !== e.target.id) {
        let calcoTop = rect.top;
        let calcLeft = rect.left;

        // for external editor case
        if (
          !this.props.isSeparateToolbar &&
          !this.props.isEditableTextAreaClauseOptionEditor &&
          !this.props.isEditableTablePlaceholderComponent
        ) {
          const listWrapper = this.listWrapperRef;
          const listWrapperRect = listWrapper.getBoundingClientRect();
          calcoTop = rect.top - listWrapperRect.top - 10;
          if (rect.top === 661) {
            calcoTop -= 40;
          }
          calcLeft = 195;
        } else if (
          this.props.isSeparateToolbar ||
          this.props.isEditableTextAreaClauseOptionEditor ||
          this.props.isEditableTablePlaceholderComponent
        ) {
          calcoTop = rect.top - 163;
          calcLeft = rect.left - 10;

          if (rect.top < 200) {
            calcoTop = rect.top - 130;
          }
          if (rect.top > 450) {
            calcoTop = rect.top - 196;
          }
          if (rect.top > 500 && rect.top < 550) {
            calcoTop = rect.top - 196;
          }
          if (rect.top > 570) {
            calcoTop = rect.top - 229;
          }

          // for text area clause option editor toolbar case
          if (
            this.props.isEditableTextAreaClauseOptionEditor ||
            this.props.isEditableTablePlaceholderComponent
          ) {
            if (window.innerWidth <= 600) {
              calcLeft = 120;
              calcoTop += 60;
            } else {
              calcLeft = rect.left;
              if (this.props.showForm && !this.props.isSharedDocument) {
                calcLeft = rect.left - 200;
              }
              calcoTop -= 10;
            }
          }
        }
        this.setState({
          hoveredID: e.target.id,
          style: {
            top: calcoTop,
            left: calcLeft,
          },
        });
      }
    }
  };

  _getFontStyleFamily = (e, fontFamily) => {
    e.preventDefault();
    const { textContent } = e.target;
    if (
      !(
        textContent === "Light" ||
        textContent === "Regular" ||
        textContent === "Medium" ||
        textContent === "Semibold" ||
        textContent === "Bold" ||
        textContent === "Extrabold"
      )
    ) {
      this._onChange(e.currentTarget.id, fontFamily, null, null);
    }
  };

  _getFontStyleWeight = (fontStyle, fontValue, fontWeight) => {
    let fontWeightStyle;
    switch (fontWeight) {
      case "Light":
        fontWeightStyle = "FONTWEIGHT_LIGHT";
        break;
      case "Regular":
        fontWeightStyle = "FONTWEIGHT_REGULAR";
        break;
      case "Medium":
        fontWeightStyle = "FONTWEIGHT_MEDIUM";
        break;
      case "Semibold":
        fontWeightStyle = "FONTWEIGHT_SEMIBOLD";
        break;
      case "Bold":
        fontWeightStyle = "FONTWEIGHT_BOLD";
        break;
      case "Extrabold":
        fontWeightStyle = "FONTWEIGHT_EXTRABOLD";
        break;
      default:
        fontWeightStyle = "";
    }
    this._onChange(fontStyle, fontValue, fontWeightStyle, fontWeight);
  };

  _handleRecentFontStyleChange = (event, fontStyle) => {
    event.preventDefault();
    const fontFamilyValue =
      FONT_FAMILY_OPTIONS[fontStyle.fontFamily].fontFamily;
    const fontWeightValue = fontStyle.fontWeight
      ? FONT_WEIGHT_OPTIONS[fontStyle.fontWeight].fontWeightName
      : null;
    this._onChange(
      fontStyle.fontFamily,
      fontFamilyValue,
      fontStyle.fontWeight || null,
      fontWeightValue,
    );
  };

  _getClosestFontWeight(fontStyle, fontValue) {
    const { editorState } = this.props;
    let fontWeightStyle = null;
    let fontWeight = null;
    // if no font weight, get current font weight & find closed one
    const currentInlineStyles = editorState.getCurrentInlineStyle();
    if (currentInlineStyles && currentInlineStyles.size > 0) {
      const oldFontWeight = currentInlineStyles.filter(style =>
        style.startsWith("FONTWEIGHT"),
      );
      if (oldFontWeight && oldFontWeight.size > 0) {
        const { newFontWeightStyle, newFontWeight } = getClosestFontWeightStyle(
          [...oldFontWeight][0],
          fontStyle,
          fontValue,
        );
        fontWeightStyle = newFontWeightStyle;
        fontWeight = newFontWeight;
      }
    }
    return { newFontWeightStyle: fontWeightStyle, newFontWeight: fontWeight };
  }

  _setCurrentSelectedStyle() {
    const { editorState } = this.props;
    const newState = { fontFamilyTitle: null, fontWeight: null };

    // check if multiple styles
    if (
      editorState.getSelection() &&
      !editorState.getSelection().isCollapsed()
    ) {
      const checkCount = checkStylesInSelection(editorState, "FONTFAMILY");
      if (checkCount > 1) {
        if (
          this.state.fontFamilyTitle !== newState.fontFamilyTitle ||
          this.state.fontWeight !== newState.fontWeight
        ) {
          this.setState(newState);
        }
        return;
      }
    }

    const editorTextValue = editorState
      .getCurrentContent()
      .getPlainText("\u0001");

    Object.entries(FONT_FAMILY_OPTIONS).forEach(([key, value]) => {
      if (editorState.getCurrentInlineStyle().has(key)) {
        newState.fontFamilyTitle = value.fontFamily;
      }
    });

    Object.entries(FONT_WEIGHT_OPTIONS).forEach(([key, value]) => {
      if (editorState.getCurrentInlineStyle().has(key)) {
        newState.fontWeight = value.fontWeightName;
      }
    });

    if (newState.fontFamilyTitle === null && editorTextValue === "") {
      if (this.props.metaData && this.props.metaData.FONTFAMILY) {
        newState.fontFamilyTitle =
          FONT_FAMILY_OPTIONS[this.props.metaData.FONTFAMILY].fontFamily;
        if (
          this.props.metaData.FONTWEIGHT &&
          this.props.metaData.FONTWEIGHT.startsWith("FONTWEIGHT")
        ) {
          newState.fontWeight =
            FONT_WEIGHT_OPTIONS[this.props.metaData.FONTWEIGHT].fontWeightName;
        }
      } else newState.fontFamilyTitle = "Open Sans";
    }

    if (newState.fontFamilyTitle === null)
      newState.fontFamilyTitle = "Open Sans";

    if (
      this.state.fontFamilyTitle !== newState.fontFamilyTitle ||
      this.state.fontWeight !== newState.fontWeight
    ) {
      this.setState(newState);
    }
  }

  render() {
    const { activeToolbarDropDown, metaData: { recentStyles } = {} } =
      this.props;

    const isRecentFontStylesAvailable =
      recentStyles &&
      Array.isArray(recentStyles.fontStyles) &&
      recentStyles.fontStyles.length > 0;
    return (
      <div
        className="draft-edit-items custom-font-style"
        ref={ele => {
          this.node = ele;
        }}>
        <Tooltip
          placement="top"
          overlay="Font"
          align={{
            offset: [3, 0],
          }}>
          <button
            data-test="custom-font-style-btn"
            className={`toolbar-custom-inline-button toolbar-btn option-font-type ${
              activeToolbarDropDown === "FONT_STYLE" ? "active" : ""
            }`}
            type="button"
            onMouseDown={this._toggleDropdown}>
            <span className="font-title">{this.state.fontFamilyTitle}</span>
            <i className="ic-dropdown">
              <FontAwesomeIcon
                icon={["far", "angle-down"]}
                className="breadcrumb-bredcrumb-icon"
              />
            </i>
          </button>
        </Tooltip>
        {activeToolbarDropDown === "FONT_STYLE" && (
          <div className="custom-font-style-wrapper">
            <div
              ref={ele => {
                this.listWrapperRef = ele;
              }}
              className="custom-font-style-container">
              <ul className={"custom-font-style-options show-scrollbar"}>
                {isRecentFontStylesAvailable && (
                  <Fragment>
                    <div className="custom-font-style-dropdown-label">
                      Document Fonts
                    </div>

                    <div className="recent-font-styles-wrapper">
                      <ul className="custom-font-style-options show-scrollbar">
                        {Array.isArray(recentStyles.fontStyles) &&
                          recentStyles.fontStyles.map(fontStyle => {
                            const fontFamilyValue =
                              FONT_FAMILY_OPTIONS[fontStyle.fontFamily]
                                .fontFamily;

                            const styles = {};
                            if (fontStyle.fontFamily) {
                              styles.fontFamily = fontFamilyValue;
                            }
                            if (fontStyle.fontWeight) {
                              styles.fontWeight =
                                FONT_WEIGHT_OPTIONS[
                                  fontStyle.fontWeight
                                ].fontWeight;
                            }

                            return (
                              <li // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                                role="button"
                                className={`custom-font-style-list-item`}
                                tabIndex={0}
                                onMouseDown={e =>
                                  this._handleRecentFontStyleChange(
                                    e,
                                    fontStyle,
                                  )
                                }
                                value={fontFamilyValue}
                                // eslint-disable-next-line prettier/prettier
                              style={styles}>
                                <span className="font-title">
                                  {fontFamilyValue}
                                  {fontStyle.fontWeight
                                    ? ` - ${
                                        FONT_WEIGHT_OPTIONS[
                                          fontStyle.fontWeight
                                        ].fontWeightName
                                      }`
                                    : ""}
                                </span>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </Fragment>
                )}
                <div className="custom-font-style-dropdown-label">
                  Standard Fonts
                </div>
                {Object.entries(FONT_FAMILY_OPTIONS).map(([key, value]) => {
                  const optionsAvailable = FONT_STYLES_WITH_OPTIONS.includes(
                    value.fontFamily,
                  );
                  const isActive =
                    value.fontFamily === this.state.fontFamilyTitle;
                  return (
                    <li // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                      role="button"
                      ref={ele => {
                        this.listRef[key] = ele;
                      }}
                      className={`custom-font-style-list-item ${
                        isActive ? "active" : ""
                      } ${optionsAvailable ? " list-with-dropdown  " : " "}`}
                      id={key}
                      tabIndex={0}
                      onMouseDown={e => {
                        this._getFontStyleFamily(e, value.fontFamily);
                      }}
                      onMouseOver={
                        optionsAvailable ? this._setListDropdownStyles : null
                      }
                      onFocus={() => {}}
                      value={value.fontFamily}
                      // eslint-disable-next-line prettier/prettier
                      style={{ fontFamily: value.fontFamily }}
                    >
                      {optionsAvailable ? (
                        <FontWeightDropdown
                          fontStyle={key}
                          style={this.state.style}
                          fontValue={value.fontFamily}
                          getFontStyleWeight={this._getFontStyleWeight}
                          currentFontWeight={this.state.fontWeight}
                          isParentActive={isActive}
                        />
                      ) : null}
                      <span className="font-title">{value.fontFamily}</span>
                      {optionsAvailable ? (
                        <i className="ic-dropdown">
                          <FontAwesomeIcon
                            icon={["far", "angle-right"]}
                            className="breadcrumb-bredcrumb-icon"
                          />
                        </i>
                      ) : null}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  }
}
